import React, { FC, useCallback } from "react";

import {
    AngiAutoresponderQuestionStep,
    AngiAutoResponderQuestionStepProps,
} from "../../components/V3/AngiAutoresponderQuestionStep";

import { OnboardingProps } from "../../models";

export interface AngiAutoResponderQuestionStepContainerProps
    extends Pick<AngiAutoResponderQuestionStepProps, "aside" | "style" | "className"> {
    initialProps?: OnboardingProps;

    onNext(props: OnboardingProps): void;
    onBack?(): void;
}

export const AngiAutoResponderQuestionStepContainer: FC<AngiAutoResponderQuestionStepContainerProps> = (props) => {
    const { initialProps, onNext, onBack } = props;

    const handleAngiAutoresponder = useCallback(
        (hasAngiAutoresponder: boolean) => {
            onNext({
                ...initialProps,
                beta: {
                    ...initialProps?.beta,
                    onboarding: {
                        ...initialProps?.beta?.onboarding,
                        hasAngiAutoresponder,
                    },
                },
            });
        },
        [initialProps, onNext]
    );
    const handleBack = useCallback(() => {
        if (typeof onBack === "function") {
            onBack();
        }
    }, [onBack]);

    return <AngiAutoresponderQuestionStep {...props} onNext={handleAngiAutoresponder} onBack={handleBack} />;
};
